import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Logo from "@/components/Logo";

export default function PublicShell({ children }) {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#F0ECE0] text-[#0A0A08] flex flex-col">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#F0ECE0]/80 border-b border-[#D2CDBE]">
        <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="public-logo">
            <Logo variant="wordmark" size={36} />
          </Link>
          <nav className="hidden md:flex items-center gap-7 text-sm text-[#0A0A08]">
            <Link to="/about" className="hover:text-[#1B3526]" data-testid="public-nav-about">About</Link>
            <Link to="/privacy" className="hover:text-[#1B3526]" data-testid="public-nav-privacy">Privacy</Link>
            <Link to="/terms" className="hover:text-[#1B3526]" data-testid="public-nav-terms">Terms</Link>
            <Link to="/help" className="hover:text-[#1B3526]" data-testid="public-nav-help">Help</Link>
            <Link to="/login" className="hover:text-[#1B3526]" data-testid="public-nav-login">Sign in</Link>
          </nav>
          <div className="flex items-center gap-2">
            <Button
              variant="ghost"
              className="hidden sm:inline-flex text-[#0A0A08] hover:bg-[#E3DECF]"
              onClick={() => navigate("/login")}
              data-testid="public-cta-login"
            >
              Sign in
            </Button>
            <Button
              className="bg-[#1B3526] hover:bg-[#0F2517] text-white rounded-lg"
              onClick={() => navigate("/register")}
              data-testid="public-cta-register"
            >
              Open account
            </Button>
          </div>
        </div>
      </header>
      <main className="flex-1">{children}</main>
      <footer className="border-t border-[#D2CDBE] mt-16">
        <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-10 grid md:grid-cols-3 gap-8 text-sm text-[#4F4D45]">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <Logo variant="mark" size={28} />
              <span className="font-display font-bold text-[#0A0A08]">FinVault</span>
            </div>
            <p className="leading-relaxed">A grounded, secure wallet built for a calmer way to move money. Personal & business accounts, demo & live banking.</p>
          </div>
          <div>
            <div className="text-eyebrow text-[#0A0A08] mb-3">Product</div>
            <ul className="space-y-2">
              <li><Link to="/about" className="hover:text-[#1B3526]">About FinVault</Link></li>
              <li><Link to="/register" className="hover:text-[#1B3526]">Open an account</Link></li>
              <li><Link to="/login" className="hover:text-[#1B3526]">Sign in</Link></li>
            </ul>
          </div>
          <div>
            <div className="text-eyebrow text-[#0A0A08] mb-3">Trust</div>
            <ul className="space-y-2">
              <li><Link to="/privacy" className="hover:text-[#1B3526]">Privacy policy</Link></li>
              <li><Link to="/terms" className="hover:text-[#1B3526]">Terms of service</Link></li>
              <li><Link to="/help" className="hover:text-[#1B3526]">Contact support</Link></li>
              <li><Link to="/verify" className="hover:text-[#1B3526]">Verify a receipt</Link></li>
              <li>2FA · TOTP · Email OTP</li>
              <li>PCI-aware card handling</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-[#D2CDBE] py-4 text-center text-xs text-[#4F4D45]">© 2026 FinVault. All rights reserved.</div>
      </footer>
    </div>
  );
}
